module.exports = __webpack_public_path__ + "static/media/Elekid_gaussian2.5bb52d6a.png";